<div class="main">
  <div class="flex justify-between items-center gap-4">
    <h2 class="text-2xl">
      {{ DashboardTranslateKeys.RECRUITMENT_PERF | translate }}
    </h2>
    <div class="header__splitter grow"></div>
    <p-button
      outlined="true"
      severity="secondary"
      (click)="toggleContent()"
      [icon]="isCollapsed() ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
    />
  </div>
  <div
    class="content transition-all duration-300 ease-in-out overflow-hidden"
    [ngClass]="{
      'h-auto opacity-100': !isCollapsed(),
      'h-0 opacity-0': isCollapsed()
    }"
  >
    <div class="grid grid-cols-3 gap-3">
      <div class="stats__card">
        <h4 class="text-white font-semibold">
          {{ DashboardTranslateKeys.TOTAL_APPLICANTS_RECEIVED | translate }}
        </h4>
        <h5 class="text-white/60 mt-2">
          {{ DashboardTranslateKeys.INFLUX_TALENT | translate }}
        </h5>
        <app-filters
          [showYearPicker]="true"
          [softColor]="true"
          [firstSelectOptions]="appPostToFillFilters"
          [secondSelectOptions]="appReceivedSecondFilters"
          [disabled]="isLoadingReceivedApplications()"
          (yearPickerChanged)="updateReceivedAppsYear($event)"
          (firstSelectChanged)="updateJobsCount($event)"
          (secondSelectChanged)="updateReceivedAppsContractType($event)"
        />
        <h1 class="text-5xl mt-7">
          {{ receivedApplicationsNumber() | numberSpace }}
        </h1>
      </div>
      <div class="stats__card">
        <h4 class="text-[#44546F] font-semibold">
          {{ DashboardTranslateKeys.TOTAL_APPLICANTS_RECRUITED | translate }}
        </h4>
        <h5 class="text-[#626F86] mt-2">
          {{ DashboardTranslateKeys.TALENTS_INTEGRATED | translate }}
        </h5>
        <app-filters
          [showMonthYearPicker]="true"
          [firstSelectOptions]="appRecrutedFilters"
          [disabled]="isLoadingAcceptedApplications()"
          (monthYearPickerChanged)="updateAcceptedAppsMonthYear($event)"
          (firstSelectChanged)="updateAcceptedAppsDepartement($event)"
        />
        <h1 class="text-5xl mt-7">
          {{ acceptedApplicationsNumber() | numberSpace }}
        </h1>
      </div>
      <div class="stats__card">
        <h4 class="text-[#44546F] font-semibold">
          {{ DashboardTranslateKeys.POSITIONS_TO_BE_FILLED | translate }}
        </h4>
        <h5 class="text-[#626F86] mt-2">
          {{ DashboardTranslateKeys.STILL_OPPORTUNITIES | translate }}
        </h5>
        <app-filters
          [showMonthYearPicker]="true"
          [firstSelectOptions]="appPostToFillFilters"
          [disabled]="isLoadingPositionsToFill()"
          (monthYearPickerChanged)="updatePositionsToFillMonthYear($event)"
          (firstSelectChanged)="updatePositionsToFillOffer($event)"
        />
        <h1 class="text-5xl mt-7">
          {{ positionsToFillNumber() | numberSpace }}
        </h1>
      </div>
      <div class="stats__card col-span-3">
        <h4 class="text-[#44546F] font-semibold">
          {{
            DashboardTranslateKeys.NUMBER_RECRUITMENTS_CARRIED_OUT | translate
          }}
        </h4>
        <h5 class="text-[#626F86] mt-2">
          {{ DashboardTranslateKeys.BY_DEFINITVE_OBJECTIVE | translate }}
        </h5>
        <app-filters
          [showYearPicker]="true"
          [disabled]="isLoadingRecrChart()"
          (yearPickerChanged)="updateRecrCarriedOutYear($event)"
        />
        <div class="mt-7">
          @if(isLoadingRecrChart() || !recruitmentsCarriedOut().length) {
          <app-skeleton-dash-card />
          }@else {
          @defer (on viewport; prefetch on idle) {
          <app-bar-chart
            id="recruitment"
            [objects]="recruitmentsCarriedOut()"
          />
          } @placeholder {
          <app-skeleton-dash-card />
          }
          }
        </div>
      </div>
    </div>
  </div>
</div>
